"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ClearFix = function ClearFix() {
  return "\n  &:before,\n  &:after {\n    clear: both;\n    display: table;\n    content: \"\";\n    line-height: 0;\n  }\n";
};

exports.default = ClearFix;